import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors, Text } from "../../config/Constants";
import Button from "../Button";
import Search from "../Search";
import Selectfield from "../Merchant/Selectfield";

interface Props {
  searchQuery: any;
  type: any;
  onSearch: any;
  onTypeChange: any;
}

const PromotionHeader = ({
  onSearch,
  searchQuery,
  type,
  onTypeChange,
}: Props) => {
  const navigate = useNavigate();

  return (
    <StyledYachtClubHeader>
      <StyledPageHeader>{"Promotions"}</StyledPageHeader>
      <StyledHeaderFields>
        <Search
          placeholder="Search promo code"
          onChange={onSearch}
          value={searchQuery}
        />
        <div style={{ width: "250px" }}>
          <Selectfield
            onChange={onTypeChange}
            value={type}
            data={[
              { label: "All", value: "" },
              { label: "Active", value: "true" },
              { label: "Inactive", value: "false" },
            ]}
            name={""}
          />
        </div>

        <PromotionActions>
          <Button
            variant="filled"
            label={"Create Promotion"}
            color={Colors.red}
            onClick={() => {
              navigate(`/admin/create-promo`);
            }}
          ></Button>
        </PromotionActions>
      </StyledHeaderFields>
    </StyledYachtClubHeader>
  );
};

const StyledHeaderFields = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  @media only screen and (max-width: 1280px) {
    flex-direction: column;
  }
`;
const StyledYachtClubHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.25rem;
  @media only screen and (max-width: 1280px) {
    flex-direction: column-reverse;
  }
  @media only screen and (max-width: 768px) {
    padding: 1rem;
    padding-bottom: 0;
  }
`;

export const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  color: ${Colors.black};
  font-weight: 500;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const PromotionActions = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
  @media only screen and (max-width: 1280px) {
    align-self: flex-end;
  }
`;

export default PromotionHeader;
